import { BoxBase, CardBase, StackBase } from '@fmc-digital/ui';
import { PaletteColor, useTheme } from '@mui/material';
import { default as SkeletonBase } from '@mui/material/Skeleton';
import React, { useMemo } from 'react';
import { get } from 'lodash';

export const BundleOfferSkeleton = ({ bgColor = '' }: { bgColor?: any }) => {
    const theme = useTheme();

    const bgcolor = useMemo(() => {
        return get(theme.palette, [bgColor, 'light'], '#E6EDF0');
    }, [bgColor, theme.palette]);
    return (
        <CardBase sx={{ bgcolor: get(theme.palette, [bgColor, 'lighter'], '#FEFEFE') }}>
            <StackBase spacing={2} direction="row">
                <SkeletonBase width={64} height={64} variant="rounded" sx={{ bgcolor }} />
                <StackBase spacing="1rem" width="100%">
                    <SkeletonBase width={'100%'} height={32} variant="rounded" sx={{ bgcolor }} />
                    <SkeletonBase width={'100%'} height={16} variant="rounded" sx={{ bgcolor }} />
                    <SkeletonBase width={'100%'} height={16} variant="rounded" sx={{ bgcolor }} />
                    <BoxBase sx={{ alignSelf: 'end' }}>
                        <SkeletonBase width={'100%'} height={32} variant="rounded" sx={{ bgcolor }} />
                    </BoxBase>
                </StackBase>
            </StackBase>
        </CardBase>
    );
};
